import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconImage = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 20 20"
    data-fill-none
  >
    <path
      d="M15.3335 3.14258H4.66688C3.8253 3.14258 3.14307 3.82481 3.14307 4.66639V15.3331C3.14307 16.1746 3.8253 16.8569 4.66688 16.8569H15.3335C16.1751 16.8569 16.8574 16.1746 16.8574 15.3331V4.66639C16.8574 3.82481 16.1751 3.14258 15.3335 3.14258Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33329 8.47712C7.96447 8.47712 8.47614 7.96545 8.47614 7.33426C8.47614 6.70308 7.96447 6.19141 7.33329 6.19141C6.7021 6.19141 6.19043 6.70308 6.19043 7.33426C6.19043 7.96545 6.7021 8.47712 7.33329 8.47712Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.857 12.2861L13.0475 8.47656L4.6665 16.8575"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconImage.displayName = 'IconImage';
